import { networkContext } from '@ubi/js-utils/http'
import { createApp } from 'vue'
import { registerPlugins } from '@/plugins'
import App from './App.vue'
import { REALM } from './configs/keycloak'
import { resolveEndpoint } from './lib/services'
import { useAuthStore } from './plugins/auth'

const init = async () => {
    const app = createApp(App)

    registerPlugins(app)
    const authStore = useAuthStore()

    await authStore.init(REALM)
    networkContext.setup({
        getEndpoint: resolveEndpoint,
        getAuthorization: () => {
            return authStore.getAuthorization()
        },
        getGlobalHeaders: () => ({}),
    })

    app.mount('#app')
}

init()
